import { useEffect, useState } from "react";
import _ from 'lodash';
import ContentSlider from '../slider/review';
import ProviderSlider from '../slider/review-provider';

export default function Review(props) {
    const { t, subscriptionStatus, reviewSectionContent, providerContent, openModal, setSlideIndex, setVideoIndex, slideNumber } = props;
    const [maxStar, setMaxStar] = useState(5);
    const [slideExist, setSlideExist] = useState(true);
    const [topParagraphData, setTopParagraphData] = useState('');
    const [bottomParagraphData, setBottomParagraphData] = useState('');
    const [gameProviderSlide, setGameProviderSlide] = useState(false);
    const [gatewaySlide, setGatewaySlide] = useState(false);

    // content rating
    let positivepoint = _.range(0, parseInt(reviewSectionContent.rating));
    let negativepoint = _.range(0, maxStar - parseInt(reviewSectionContent.rating));

    let tabName = [];
    /////////// Hard coded provider slide, pls change accordingly if needed coz needed to complete it in time ///////////
    useEffect(() => {
        // content spliting
        // console.log(reviewSectionContent.text_content);
        let middleContent = _.split(reviewSectionContent.text_content, '{{slides}}');
        // console.log(middleContent);
        if(middleContent.length == 1){
            setSlideExist(false);
        }

        let topParagraph = !_.isEmpty(middleContent[0]) ? middleContent[0] : '';
        let bottomSection = !_.isEmpty(middleContent[1]) ? middleContent[1] : '';
        let bottomParagraph = '';
        let gameProviderExist = bottomSection.indexOf('{{provider.game}}'); // -1 meaning not found
        let gatewayProviderExist = bottomSection.indexOf('{{provider.payment}}'); // -1 meaning not found

        if(gameProviderExist == -1 && gatewayProviderExist == -1){
            // Both not found
            bottomParagraph = bottomSection;
        }
        else{
            if(gameProviderExist >= 0 && gatewayProviderExist >= 0){
                // Both found
                setGameProviderSlide(true);
                setGatewaySlide(true);
            }
            else if(gameProviderExist >= 0){
                // Found game provider
                setGameProviderSlide(true);
                let bottomPart = _.split(bottomSection, '{{provider.game}}');
                bottomParagraph = _.isEmpty(bottomPart[0]) ? bottomPart[0] : '' + _.isEmpty(bottomPart[1]) ? bottomPart[1] : '';
            }
            else if(gatewayProviderExist >= 0){
                // Found payment gateway provider
                setGatewaySlide(true);
                let bottomPart = _.split(bottomSection, '{{provider.payment}}');
                bottomParagraph = _.isEmpty(bottomPart[0]) ? bottomPart[0] : '' + _.isEmpty(bottomPart[1]) ? bottomPart[1] : '';
            }
        }
        setTopParagraphData(topParagraph)
        setBottomParagraphData(bottomParagraph);
    }, []);

    _.forEach(reviewSectionContent.slides, function(value){
        tabName.push(value.slide_name);
    });

    return (
        <>
            <div className="payment-review-box">
                <div className="media">
                    <span>{subscriptionStatus ? <img src="/assets/images/verified-icon.svg" alt="" /> : <img src="/assets/images/not-verified-icon.svg" alt="" /> }</span>
                    <ul className="ratting" style={{ marginTop: '0' }}>
                        {_.map(positivepoint, pp => (
                            <li key={pp} style={{ width: '35px', height: '35px' }}><img src="/assets/images/review-star-filled.svg" alt="" className="img-fluid w-100" /></li>
                        ))}
                        {_.map(negativepoint, np => (
                            <li key={np} style={{ width: '35px', height: '35px' }}><img src="/assets/images/review-star-empty.svg" alt="" className="img-fluid w-100" /></li>
                        ))}
                    </ul>
                </div>
                <div className="text-box">
                    <h1>{reviewSectionContent.tab_name}</h1>
                    <p dangerouslySetInnerHTML={{ __html: topParagraphData }} />
                </div>
                {slideExist && 
                    <ContentSlider
                        slidesList={reviewSectionContent.slides}
                        tabName={tabName}
                        openModal={openModal}
                        setSlideIndex={setSlideIndex}
                        setVideoIndex={setVideoIndex}
                        slideNumber={slideNumber}
                        {...props}
                    />
                }
                <div className="text-box">
                    <p dangerouslySetInnerHTML={{ __html: bottomParagraphData }} />
                </div>
                {gameProviderSlide && 
                    <>
                        <ProviderSlider
                            providerList={providerContent.game}
                            title={t('All_providers')}
                            {...props}
                        />
                    </>
                }
                {gatewaySlide && 
                    <>
                        <ProviderSlider
                            providerList={providerContent.payment}
                            title={t('All_options')}
                            {...props}
                        />
                    </>
                }
            </div>
        </>
    )
}